import React from 'react';
import { Check, Camera, TestTube, Smartphone } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function QualityCheckpointsSection() {
  const checkpoints = [{
    icon: Check,
    title: 'Pre-Install Walkthrough',
    description: 'You approve the final plan before any work starts. No surprises.'
  }, {
    icon: Camera,
    title: 'Documentation Before Cover',
    description: 'We photograph and mark every cable/tube run before pouring or covering. This becomes your as-built record.'
  }, {
    icon: TestTube,
    title: 'System Testing',
    description: 'Electric: continuity + megger (insulation resistance) tests on every circuit. Hydronic: pressure tests on every loop. Results documented.'
  }, {
    icon: Smartphone,
    title: 'Commissioning Demo',
    description: 'We power up the system with you present, walk through controls, verify sensor response, and confirm everything works.'
  }];
  return <section className="py-16 bg-slate-900 text-white md:py-24" data-id="element-537">
      <div className="container mx-auto px-4 md:px-6" data-id="element-538">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-539">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-540">
            Built-In Quality Checkpoints
          </h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-541">
            We don't just hope it works. We prove it at every stage.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-542">
          {checkpoints.map((point, index) => <Card key={index} className="bg-slate-800 border-slate-700 text-white hover:bg-slate-750 transition-colors" data-id="element-543">
              <CardContent className="p-6" data-id="element-544">
                <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center mb-4 text-primary-foreground border border-primary/30" data-id="element-545">
                  <point.icon className="h-6 w-6" data-id="element-546" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-547">{point.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-548">
                  {point.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}